import { createSlice } from "@reduxjs/toolkit";

const appState = createSlice({
  name: "appState",
  initialState: {
    showCompleteUserProfileModal: false,
  },
  reducers: {
    setAppState(_state, action) {
      return {
        ..._state,
        ...action.payload,
      };
    },
  },
});

export const { setAppState } = appState.actions;
export default appState.reducer;
